import { type ColumnDef } from '@tanstack/react-table';
import { TradeItem } from '@/types';
import { createTradesColumns } from '@/features/trades/components';

/**
 * MTM column set = the Trades columns minus `counterparty`. Trade Gross Price
 * (gross_price) is now always emitted by createTradesColumns (LR-522 un-gated it
 * — it shows on both the MtM grid and the Trades blotter), so no special option
 * is needed. Counterparty is fixed by the active subtab on the MTM page, so the
 * column is redundant here. Read-only: createTradesColumns is called with no
 * action handlers, and each lifecycle action button (Set Date / Terminate /
 * Settle / Settle Cash / Settle Securities / Give Notice / MTM) is render-gated
 * on its handler in trades-columns.tsx, so none of them render here.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function createMtmColumns(origin?: { cp?: number }): ColumnDef<TradeItem, any>[] {
  // LR-478: rows opened from the MTM grid carry from='mtm' + the active
  // counterparty scope (cp) into the single-trade breadcrumb, so "back" returns
  // to this same scoped MTM view. cp omitted (unscoped MTM) → breadcrumb returns
  // to unscoped MTM.
  const allCols = createTradesColumns({
    origin: { from: 'mtm', cp: origin?.cp },
  });
  return allCols.filter((col) => {
    const id = (col as { accessorKey?: string }).accessorKey ?? col.id;
    return id !== 'counterparty';
  });
}
